import { gql } from '@apollo/client';

export const GET_COMPANY_FORM_INSTANCE = gql`
  query FORM_SERVICE_getFormInstances($enrollmentPeriodId: String!) {
    getCompanyInfoFormInstances(enrollmentPeriodId: $enrollmentPeriodId) {
      id
      form {
        id
        formTitle
        sections {
          title
          key
          layout
          showWhen
        }
      }
      enrollmentPeriodId
      status
      answers {
        common
        custom
      }
    }
  }
`;

export const GET_FORM_INSTANCE = gql`
  query FORM_SERVICE_getFormInstance($formInstanceId: String!) {
    formInstanceById(formInstanceId: $formInstanceId) {
      id
      form {
        id
        formTitle
        sections {
          title
          key
          layout
          showWhen
        }
      }
      enrollmentPeriodId
      status
      answers {
        common
        custom
      }
    }
  }
`;

export const GET_WEB_FORM_INSTANCES = gql`
  query FORM_SERVICE_getWebFormInstances($enrollmentPeriodId: String!) {
    getWebFormInstances(enrollmentPeriodId: $enrollmentPeriodId) {
      id
      form {
        id
        formTitle
        roleAvailability
      }
      productLineIds
      enrollmentPeriodId
      status
    }
  }
`;

export const GET_RENEWAL_FORM_INSTANCES = gql`
  query FORM_SERVICE_getRenewalFormInstances($enrollmentPeriodId: String!) {
    getRenewalFormInstances(enrollmentPeriodId: $enrollmentPeriodId) {
      id
      form {
        id
        formTitle
        roleAvailability
      }
      productLineIds
      enrollmentPeriodId
      status
    }
  }
`;

export const SET_ANSWERS = gql`
  mutation FORM_SERVICE_setAnswers($formInstanceId: String!, $answers: InputFormAnswers!, $complete: Boolean = false) {
    setAnswers(formInstanceId: $formInstanceId, answers: $answers, complete: $complete) {
      id
      form {
        id
        formTitle
        sections {
          title
          key
          layout
          showWhen
        }
      }
      enrollmentPeriodId
      status
      answers {
        common
        custom
      }
    }
  }
`;

export const GET_BC_FORMS = gql`
  query FORM_SERVICE_getBCFormsByPortfolioId($portfolioId: String!, $effectiveDate: String!) {
    getBCFormsByPortfolioId(portfolioId: $portfolioId, effectiveDate: $effectiveDate) {
      id
      formTitle
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;
export const GET_BROWSING_PORTFOLIO_CONFIG_FORM = gql`
  query FORM_SERVICE_getBrowsingConfigFormByPortfolioId($portfolioId: String!, $effectiveDate: String!) {
    getBrowsingConfigFormByPortfolioId(portfolioId: $portfolioId, effectiveDate: $effectiveDate) {
      id
      formTitle
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const GET_CONTRIBUTION_FORM_INSTANCE = gql`
  query FORM_SERVICE_getFormInstances($enrollmentPeriodId: String!) {
    getContributionFormInstances(enrollmentPeriodId: $enrollmentPeriodId) {
      id
      form {
        id
        formTitle
        sections {
          title
          key
          layout
          showWhen
        }
      }
      enrollmentPeriodId
      status
      answers {
        common
        custom
      }
    }
  }
`;

export const GET_FORM_BY_ID = gql`
  query FORM_SERVICE_getFormById($id: ID!, $bc: Map) {
    getFormById(id: $id, bc: $bc) {
      id
      formTitle
      description
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const GET_ELECTION_FORM_BY_ID = gql`
  query FORM_SERVICE_getElectionFormById($id: ID!, $carrierId: String!, $clazz: String, $productId: String) {
    getElectionFormById(id: $id, carrierId: $carrierId, clazz: $clazz, productId: $productId) {
      id
      formTitle
      description
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const GET_MANAGE_DEPENDENTS_FORM = gql`
  query FORM_SERVICE_getManageDependentsForm(
    $id: ID!
    $answers: InputFormAnswers!
    $dependentId: String
    $sponsorId: String
  ) {
    getManageDependentsForm(id: $id, answers: $answers, dependentId: $dependentId, sponsorId: $sponsorId) {
      id
      formTitle
      description
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const MARK_FORMS_AS_INACTIVE = gql`
  mutation FORM_SERVICE_markFormsAsInactive($periodId: String!) {
    markFormsAsInactive(periodId: $periodId)
  }
`;

export const GENERATE_ATTR_FORM_BY_POLICY_ATTR_ANSWERS = gql`
  mutation FORM_SERVICE_generateAttrFormByPolicyAttrAnswers(
    $formId: String!
    $planAttr: String!
    $policyAttrAnswers: Map!
    $sponsorId: String
  ) {
    generateAttrFormByPolicyAttrAnswers(
      formId: $formId
      planAttr: $planAttr
      policyAttrAnswers: $policyAttrAnswers
      sponsorId: $sponsorId
    ) {
      id
      formTitle
      description
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const GET_RATE_RFQ_FORM = gql`
  query FORM_SERVICE_getRateRfqForm(
    $id: ID!
    $portfolioId: String!
    $portfolioName: String!
    $products: [InputProduct]!
    $sponsorId: String
  ) {
    getRateRfqForm(
      id: $id
      portfolioId: $portfolioId
      portfolioName: $portfolioName
      products: $products
      sponsorId: $sponsorId
    ) {
      id
      formTitle
      description
      sections {
        title
        key
        layout
        showWhen
      }
    }
  }
`;

export const GET_FORM_INSTANCES = gql`
  query FORM_SERVICE_getFormInstance($periodId: String!, $formType: FormType!) {
    getFormInstances(periodId: $periodId, formType: $formType) {
      id
      form {
        id
        formTitle
        sections {
          title
          key
          layout
          showWhen
        }
      }
      enrollmentPeriodId
      status
      answers {
        common
        custom
      }
    }
  }
`;
